import * as HLF from "html-living-framework";
import * as PIXI from "pixi.js";
import {Anchor} from "../Core/Anchor";
import {Ease} from "../Core/Animatable";
import {Container} from "../Core/Container";
import {Callback} from "../Core/Reflection";
import {Sprite} from "../Core/Sprite";
import {Keyboard} from "../GameObjects/Keyboard";
import {SplashPlayButton} from "../GameObjects/SplashPlayButton";
import {main} from "../Layout/StartScreenLayout";
import {AudioChannel} from "../Core/AudioChannel";
import {Analytics} from "../Managers/Analytics";

export class StartScreen extends HLF.LoadScreen {

    public readonly bg = this.addChild(new Sprite(PIXI.Texture.WHITE, Anchor.middleCenter));
    public readonly main = this.addChild(new Container());
    public readonly background = this.main.addChild(new Sprite());
    public readonly loader = this.main.addChild(new Sprite());
    public readonly buttonPlay = this.main.addChild(new SplashPlayButton(undefined, () => this.onClickPlay()));

    private _onLoaded?: Callback;
    private _isAnimatedIn = false;

    public init(pSize: PIXI.Point) {
        super.init(pSize);

        main.call(this);
        this.main.scale.set(0.5);

        this.bg.tint = 0x2f94e3;

        this.loader.tweenTo(0.8, Ease.none, {
            rotation: -Math.PI * 2,
            repeat: -1,
        });
        this.loader.scaleFrom(0, 0.2, Ease.sineOut, () => {
            this.loader.delayedCall(0.4, () => {
                this._isAnimatedIn = true;
                this.showPlayButton();
            });
        });
        this.buttonPlay.visible = false;
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);

        this.bg.width = this._size.x;
        this.bg.height = this._size.y;
    }

    public onLoadComplete(pCallback: () => void): void {
        this._onLoaded = pCallback;
        main.call(this);
        this.showPlayButton();
    }

    private showPlayButton() {
        if (this._isAnimatedIn && this._onLoaded) {
            Analytics.event("startGame");
            this.loader.moveYTo(this._size.y + this.loader.height, 0.2, Ease.sineIn, () => {
                this.loader.visible = false;
                this.buttonPlay.visible = true;
                this.buttonPlay.moveYFrom(this._size.y + this.buttonPlay.height, 0.4, Ease.backOut, () => {
                    this.buttonPlay.pulse();
                });
                Keyboard.add(this.buttonPlay);
            });
        }
    }

    private onClickPlay() {
        this.interactiveChildren = false;
        Keyboard.enabled = false;
        this.buttonPlay.moveYTo(this._size.y + this.buttonPlay.height, 0.2, Ease.sineIn, this._onLoaded);
        AudioChannel.BGM.play("LATW 064 light happy pacer time pass KK", "loop");
    }
}
